import { Helmet } from "react-helmet-async";
import { useLocation } from "react-router-dom";

const CANONICAL_BASE = "https://linkexpln.com";
const OG_IMAGE = `${CANONICAL_BASE}/og-image.jpg`;

export const Seo = ({ title, description, image }) => {
  const { pathname } = useLocation();
  const canonical = `${CANONICAL_BASE}${pathname === "/" ? "/" : pathname}`;
  const ogImage = image ? (image.startsWith("/") ? `${CANONICAL_BASE}${image}` : image) : OG_IMAGE;
  return (
    <Helmet>
      <title>{title}</title>
      <meta name="description" content={description} />
      <link rel="canonical" href={canonical} />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:type" content="website" />
      <meta property="og:url" content={canonical} />
      <meta property="og:site_name" content="LinkExpln" />
      <meta property="og:image" content={ogImage} />
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={ogImage} />
    </Helmet>
  );
};
